import Routes from "@Routes";
import { callService } from "@Views/utils/ServiceUtils";
import { isEmpty } from "@Views/utils/StringUtils";
import axios from "axios";
import { useEffect, useState } from "react";
import Highcharts from "highcharts";
import ReactGa from 'react-ga4';

Highcharts.setOptions({ lang: { thousandsSep: ",", decimalPoint: '.' } })

const App = () => {

  const [load, setLoad] = useState((isEmpty(localStorage.getItem('ipAddr')) === false && isEmpty(sessionStorage.getItem('_iecosScrLoad')) === false));

  const TRACKING_ID = 'G-ZZQKW82GCZ';

  const loadData = async () => {
    if (!localStorage.getItem('ipAddr')) {
      const res = await axios.get("/serviceEndpoint/ipcheck");

      localStorage.setItem('ipAddr', res['data']);
    }

    const scrLoad = sessionStorage.getItem('_iecosScrLoad');

    if (isEmpty(scrLoad)) {
      const res = await callService('OSUSE07R01', { scrId: 'IECOSPC', useYn: 'Y' });

      if (res['scrList']) {
        for (const scrInfo of res['scrList']) {
          sessionStorage.setItem('_#' + scrInfo['scrFilePathCtnt'], scrInfo['scrId']);
        }
      }

      sessionStorage.setItem('_iecosScrLoad', "true");
    }

    setLoad(true);
  }

  useEffect(() => {
    ReactGa.initialize(TRACKING_ID);
    if (load === false) {
      loadData();
    }
  }, [])

  return (
    <>
      {load && <Routes />}
    </>
  );
}

export default App;